import type { SliderDesignTokens, SliderTokenSections } from '@openng/optimus-ui-themes/types/slider';

export const handle: SliderTokenSections.Handle = {
	borderRadius: '{slider.handle.width} / 2',
	content: {
		borderRadius: '{slider.handle.content.width} / 2',
	},
};

export default {
	handle,
} satisfies SliderDesignTokens;
